import React from 'react';

function Pricing() {
  return (
    <div className="py-20 px-6 bg-background min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-black text-primary mb-6">Simple, Transparent Pricing</h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">One plan. Unlimited everything. Cancel anytime.</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-200">
            <div className="bg-primary p-12 text-center">
              <span className="inline-block bg-secondary text-white text-xs font-black px-4 py-2 rounded-full mb-4 tracking-widest uppercase">Pro Membership</span>
              <div className="text-white text-7xl font-black mb-2">$19</div>
              <div className="text-white/60 text-lg font-bold uppercase tracking-widest">Per Month</div>
            </div>

            <div className="p-12">
              <h3 className="text-2xl font-bold text-primary mb-8">Everything you need to run your business:</h3>

              <ul className="space-y-6 mb-12">
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">Unlimited Quotes, Change Orders & Invoices</div>
                    <div className="text-slate-600">Create unlimited quotes, document changes, and bill clients. No limits, no overages.</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">Unlimited Clients & Jobs</div>
                    <div className="text-slate-600">Manage all your clients and projects in one place.</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">Sequential Invoice Numbering</div>
                    <div className="text-slate-600">Automatic invoice numbers (INV-0001, INV-0002...) with payment terms and due dates.</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">Digital Signature Capture</div>
                    <div className="text-slate-600">Get client signatures on-site with our integrated signature pad for change orders.</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">Professional PDF Generation</div>
                    <div className="text-slate-600">Automatically generate branded PDFs for all documents with tax calculations.</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">Email Delivery</div>
                    <div className="text-slate-600">Send quotes, change orders, and invoices directly to client inboxes.</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">Priority Support</div>
                    <div className="text-slate-600">Get help when you need it with priority customer support.</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-check-circle text-success mr-4 text-2xl mt-1"></i>
                  <div>
                    <div className="font-bold text-lg mb-1">CSV Data Export</div>
                    <div className="text-slate-600">Export all your data anytime for your records or accounting.</div>
                  </div>
                </li>
              </ul>

              <div className="bg-background p-8 rounded-2xl mb-8">
                <h4 className="font-bold text-lg mb-4">Free Trial Included</h4>
                <p className="text-slate-600">Start with a free trial. No credit card required. Cancel anytime.</p>
              </div>

              <a href="/upgrade" className="block w-full bg-secondary text-white py-5 rounded-2xl font-black text-xl text-center shadow-xl hover:bg-orange-600 transition">
                START FREE TRIAL
              </a>
            </div>
          </div>
        </div>

        <div className="mt-20 max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="font-bold text-lg mb-2">Can I cancel anytime?</h3>
              <p className="text-slate-600">Yes! Cancel your subscription anytime with no penalties or fees.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="font-bold text-lg mb-2">Is there really a free trial?</h3>
              <p className="text-slate-600">Absolutely. Start with a free trial to test all features. No credit card required.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="font-bold text-lg mb-2">What platforms are supported?</h3>
              <p className="text-slate-600">Scope Order is available on both iOS and Android devices.</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="font-bold text-lg mb-2">Can I export my data?</h3>
              <p className="text-slate-600">Yes! Export all your data to CSV format anytime for your records.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
